var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('ckeditor',{attrs:{"editor":_vm.editor,"value":_vm.value,"config":_vm.editorConfig},on:{"input":_vm.handleInput,"ready":_vm.onReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }